import * as types from '../types';

// Session actions
export const startCreatingSession = (platform: string = 'web') => ({
  type: types.ACTIVITY_SESSION_CREATE_STARTED,
  payload: { platform }
});

export const completeCreatingSession = (sessionId: string) => ({
  type: types.ACTIVITY_SESSION_CREATE_COMPLETED,
  payload: { sessionId }
});

export const failCreatingSession = (error: any) => ({
  type: types.ACTIVITY_SESSION_CREATE_FAILED,
  payload: { error }
});

export const startClosingSession = (sessionId: string, status: string = 'ended') => ({
  type: types.ACTIVITY_SESSION_CLOSE_STARTED,
  payload: { sessionId, status }
});

export const completeClosingSession = () => ({
  type: types.ACTIVITY_SESSION_CLOSE_COMPLETED
});

export const failClosingSession = (error: any) => ({
  type: types.ACTIVITY_SESSION_CLOSE_FAILED,
  payload: { error }
});

// Log buffer actions
export const addActivityLog = (log: types.ActivityLogEntry) => ({
  type: types.ACTIVITY_LOG_ADDED,
  payload: log
});

export const startFlushingLogs = () => ({
  type: types.ACTIVITY_LOG_FLUSH_STARTED
});

export const completeFlushingLogs = (count: number) => ({
  type: types.ACTIVITY_LOG_FLUSH_COMPLETED,
  payload: { count }
});

export const failFlushingLogs = (error: any) => ({
  type: types.ACTIVITY_LOG_FLUSH_FAILED,
  payload: { error }
});

// Fetch logs (for audit view)
export const startFetchingActivityLogs = (filters: any = {}) => ({
  type: types.ACTIVITY_LOGS_FETCH_STARTED,
  payload: filters
});

export const completeFetchingActivityLogs = (logs: types.ActivityLogRecord[]) => ({
  type: types.ACTIVITY_LOGS_FETCH_COMPLETED,
  payload: { logs }
});

export const failFetchingActivityLogs = (error: any) => ({
  type: types.ACTIVITY_LOGS_FETCH_FAILED,
  payload: { error }
});
